import lightGallery from 'lightgallery';

// Plugins
//import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgVideo from 'lightgallery/plugins/video'


export const LightGallery = () => {

    //group images by component 
    const galleryContainer = [...document.querySelectorAll(".section:has([data-lightbox]):not(.timeline-section)")]
    if (galleryContainer.length) {
        galleryContainer.forEach(container => {
            lightGallery(container, {
                speed: 500,
                controls: true,
                download: true,
                counter: [...container.querySelectorAll('[data-lightbox]')].length > 1,
                appendCounterTo: '.lg-components',
                nextHtml: '<svg class="icon" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M21.1188 5.27134C20.3404 4.49289 19.0674 4.49289 18.2889 5.27134C17.5105 6.04978 17.5105 7.32277 18.2889 8.10122L20.203 10.0153L23.1611 12.9734H2.00565C0.897504 12.9734 0 13.8709 0 14.979C0 16.0872 0.897504 16.9847 2.00565 16.9847H23.1611L19.0949 21.0509L18.2889 21.8569C17.5105 22.6353 17.5105 23.9083 18.2889 24.6867C18.6827 25.0805 19.1956 25.2729 19.7085 25.2729C20.2213 25.2729 20.7342 25.0805 21.128 24.6867L29.4162 16.3986C30.1946 15.6201 30.1946 14.3471 29.4162 13.5687L21.1188 5.27134Z" fill="currentColor"/></svg>',
                prevHtml: '<svg class="icon" width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M8.88117 24.6896C9.65962 25.468 10.9326 25.468 11.7111 24.6896C12.4895 23.9112 12.4895 22.6382 11.7111 21.8597L9.79699 19.9456L6.83889 16.9875L27.9944 16.9875C29.1025 16.9875 30 16.09 30 14.9819C30 13.8738 29.1025 12.9763 27.9944 12.9763L6.83889 12.9763L10.9051 8.91001L11.7111 8.10409C12.4895 7.32564 12.4895 6.05265 11.7111 5.2742C11.3173 4.8804 10.8044 4.68808 10.2915 4.68808C9.77868 4.68808 9.26582 4.8804 8.87201 5.2742L0.583837 13.5624C-0.194612 14.3408 -0.194612 15.6138 0.583836 16.3923L8.88117 24.6896Z" fill="currentColor"/></svg>',
                defaultCaptionHeight: 250,
                getCaptionFromTitleOrAlt: true,
                licenseKey: '69080706-1AC0-46D4-92AC-34A021105012',
                zoom: true,
                mobileSettings: {
                    showCloseIcon: true
                },
                selector: '[data-lightbox]',
                plugins: [lgZoom, lgVideo]
            });

        });
    }



}

